<template>
  <VDialog
    class="approve-dialog-component"
		width="400px"
		:closable="!!title"
  >
		<template
			v-if="title"
			#header
		>
			<div
				:title="title"
				class="ellipsis nowrap"
			>
				{{ title }}
			</div>
		</template>

		<div class="message" v-html="message || 'Подтверждаете действие?'"></div>

		<VTextarea
			v-if="showReason"
			v-model="reasonText"
			placeholder="Укажите причину"
			text-align="left"
			class="reason-textarea"
			required
		/>

		<template #footer>
			<VButton
				theme="primary"
				@click="approve"
			>
				Да
			</VButton>
			<VButton @click="closeDialog">
				Нет
			</VButton>
		</template>
  </VDialog>
</template>

<style lang="scss" src="./VApproveDialog.scss" />

<script>
export default {
	name:   'VApproveDialog',
	props: {
		message: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			default: '',
		},
		showReason: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			reasonText: '',
		};
	},

	methods: {
		closeDialog() {
			this.$core.dialogs.VApproveDialog.hide();
      this.$emit('close');
		},

    onClose() {
      this.$emit('close');
    },

		approve() {
			this.$emit('approve', this.reasonText);
		},
	},
};
</script>
